import Vue from 'vue'
import { DD_ICONS, DD_ICON_ALIASES } from '@/icons/ddIcons'

// Renders the DoorDash icon for every Material icon name listed in DD_ICON_ALIASES (tasks#211).
// A global mixin swaps the render function of Vuetify's (non-functional) VIcon instances, so
// `<v-icon>add</v-icon>`, `prepend-icon="search"` and Vuetify's own `$expand` / `$sort` / …
// icons all follow without template changes. Names without an alias keep the Material font.
// Vuetify's SVG path support cannot be used: it draws one path without fill-rule, and the
// DoorDash outline icons need several even-odd paths.

// the edit and delete icons are the ordit-uk-web2 PencilEdit / TrashDelete at their own 20px,
// whatever size the v-icon asks for, so every edit / delete / remove action looks the same
const FIXED_SIZES = { pencil: '20px', trash: '20px' }

// Prism draws these again for 16px: the 24px artwork scaled down loses its 2px line weight
const SMALL_ARTWORK = { copy: 'copy-16', 'external-link': 'external-link-16' }
const SMALL_ARTWORK_MAX_PX = 16

// the merchant portal shows these in the default icon colour, not Vuetify's 54% grey
const INK_ICONS = { copy: true, 'select-chevron': true }

function renderDdIcon(vm, h, icon, key) {
    const size = FIXED_SIZES[key] || vm.getSize()
    if (
        SMALL_ARTWORK[key] &&
        size &&
        parseFloat(size) <= SMALL_ARTWORK_MAX_PX
    ) {
        icon = DD_ICONS[SMALL_ARTWORK[key]]
    }
    const svgData = {
        class: {
            'v-icon__svg': true,
            'dd-icon': true,
            'dd-icon--ink': INK_ICONS[key] && !vm.color,
        },
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: icon.viewBox,
            role: 'img',
            'aria-hidden': true,
        },
        style: size ? { fontSize: size, height: size, width: size } : undefined,
    }
    const paths = icon.paths.map((path) =>
        h('path', {
            attrs: path.stroke
                ? {
                      d: path.d,
                      fill: 'none',
                      stroke: 'currentColor',
                      'stroke-width': path.stroke,
                  }
                : {
                      d: path.d,
                      'fill-rule': path.evenodd ? 'evenodd' : null,
                      'clip-rule': path.evenodd ? 'evenodd' : null,
                  },
        })
    )
    const [, , width, height] = icon.viewBox.split(' ').map(Number)
    const children = icon.rotate
        ? [
              h(
                  'g',
                  {
                      attrs: {
                          transform: `rotate(${icon.rotate} ${width / 2} ${
                              height / 2
                          })`,
                      },
                  },
                  paths
              ),
          ]
        : paths

    return h(vm.hasClickListener ? 'button' : 'span', vm.getSvgWrapperData(), [
        h('svg', svgData, children),
    ])
}

Vue.mixin({
    beforeCreate() {
        const options = this.$options
        if (
            options.name !== 'v-icon' ||
            options.functional ||
            !options.render
        ) {
            return
        }
        const vuetifyRender = options.render
        options.render = function (h) {
            const name = this.getIcon()
            const key = typeof name === 'string' && DD_ICON_ALIASES[name]
            const icon = key && DD_ICONS[key]
            return icon
                ? renderDdIcon(this, h, icon, key)
                : vuetifyRender.call(this, h)
        }
    },
})
